module.exports = __webpack_public_path__ + "img/hk_no_six_month_commission.245b0f6a.png";